package com.anjuros.website.templates.template4.modules

import com.anjuros.website.templates.template4.util.ResKey


enum class Template4Review(
    val title:ResKey,
    val review:ResKey
) {
    Template4Review1(title= ResKey.TEMPLATE4_REVIEW1_TITLE, review=ResKey.TEMPLATE4_REVIEW1),
    Template4Review2(title=ResKey.TEMPLATE4_REVIEW2_TITLE, review=ResKey.TEMPLATE4_REVIEW2),
    Template4Review3(title=ResKey.TEMPLATE4_REVIEW3_TITLE, review=ResKey.TEMPLATE4_REVIEW3),
    Template4Review4(title=ResKey.TEMPLATE4_REVIEW4_TITLE, review=ResKey.TEMPLATE4_REVIEW4),
    Template4Review5(title=ResKey.TEMPLATE4_REVIEW5_TITLE, review=ResKey.TEMPLATE4_REVIEW5),
    Template4Review6(title=ResKey.TEMPLATE4_REVIEW6_TITLE, review=ResKey.TEMPLATE4_REVIEW6),
    Template4Review7(title=ResKey.TEMPLATE4_REVIEW7_TITLE, review=ResKey.TEMPLATE4_REVIEW7),
    Template4Review8(title=ResKey.TEMPLATE4_REVIEW8_TITLE, review=ResKey.TEMPLATE4_REVIEW8),
    Template4Review9(title=ResKey.TEMPLATE4_REVIEW9_TITLE, review=ResKey.TEMPLATE4_REVIEW9),
    Template4Review10(title=ResKey.TEMPLATE4_REVIEW10_TITLE, review=ResKey.TEMPLATE4_REVIEW10)
}